module.exports = __webpack_public_path__ + "img/checkout-icon-etf.eace5d0f.svg";